(function () {
  'use strict';

  function activatePlayer(player) {
    if (!player || player.dataset.activated === 'true') return;
    var mode = player.getAttribute('data-sv-mode');
    var media = player.querySelector('[data-sv-media]');
    if (!media) return;

    if (mode === 'youtube' || mode === 'vimeo' || mode === 'external') {
      var embed = player.getAttribute('data-sv-embed') || player.getAttribute('data-sv-file-url');
      if (!embed) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'sv-player__iframe';
      iframe.src = embed;
      iframe.title = 'Video player';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.setAttribute('loading', 'eager');
      media.innerHTML = '';
      media.appendChild(iframe);
    } else if (mode === 'file') {
      var url = player.getAttribute('data-sv-file-url');
      if (!url) return;
      var video = document.createElement('video');
      video.className = 'sv-player__video';
      video.src = url;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = player.getAttribute('data-sv-autoplay') === '1';
      media.innerHTML = '';
      media.appendChild(video);
      if (video.autoplay) {
        try { video.play(); } catch (e) { /* noop */ }
      }
    } else {
      return;
    }

    player.dataset.activated = 'true';
  }

  function initPlayers(container) {
    var buttons = container.querySelectorAll('[data-sv-play]');
    function onClick(e) {
      var btn = e.currentTarget;
      var player = btn.closest('[data-sv-player]');
      activatePlayer(player);
    }
    buttons.forEach(function (b) { b.addEventListener('click', onClick); });
    return function () {
      buttons.forEach(function (b) { b.removeEventListener('click', onClick); });
    };
  }

  function initShare(container) {
    var copyBtns = container.querySelectorAll('[data-msv-copy]');
    var toast = container.querySelector('[data-msv-toast]');
    if (!copyBtns.length) return null;

    var toastTimer = null;

    function showToast() {
      if (!toast) return;
      toast.hidden = false;
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 1800);
    }

    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* noop */ }
      document.body.removeChild(ta);
    }

    function copyToClipboard() {
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showToast).catch(function () {
          fallbackCopy(url);
          showToast();
        });
      } else {
        fallbackCopy(url);
        showToast();
      }
    }

    function onCopy() {
      if (navigator.share) {
        var shareData = { title: document.title, url: window.location.href };
        navigator.share(shareData).catch(function (err) {
          if (err && err.name === 'AbortError') return;
          copyToClipboard();
        });
      } else {
        copyToClipboard();
      }
    }

    copyBtns.forEach(function (b) { b.addEventListener('click', onCopy); });
    return function () {
      copyBtns.forEach(function (b) { b.removeEventListener('click', onCopy); });
      if (toastTimer) clearTimeout(toastTimer);
    };
  }

  function init(container) {
    if (!container || container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var cleanups = [];
    var c1 = initPlayers(container); if (c1) cleanups.push(c1);
    var c2 = initShare(container);   if (c2) cleanups.push(c2);

    container._msvCleanup = function () {
      cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._msvCleanup === 'function') container._msvCleanup();
    container.dataset.bound = '';
  }

  function bootAll() {
    document.querySelectorAll('[data-section-type="main-support-video"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="main-support-video"]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="main-support-video"]').forEach(destroy);
  });
})();
